import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers';

export { COMMAND_STORAGE_KEY } from './constants';

export const storage = createSessionStorageProvider('use-local-storage-command');
